import {
    hideConfirmationLayerAction,
    hideTyresAction,
    showConfirmButtonAction,
} from '../../_flux/actions/rego_lookup_actions';

export function onEdit() {
    hideTyresAction();
    showConfirmButtonAction();
    hideConfirmationLayerAction();
}
